import { render } from "./Swagger-UI.vue?vue&type=template&id=72b4ad0c&scoped=true&ts=true"
import script from "./Swagger-UI.vue?vue&type=script&lang=ts"
export * from "./Swagger-UI.vue?vue&type=script&lang=ts"

import "./Swagger-UI.vue?vue&type=style&index=0&id=72b4ad0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b4ad0c"]])

export default __exports__